module.exports = __webpack_public_path__ + "img/cards-ru.1be4b005.svg";